const SiteUtil = {
    /**
     * 活动标题/副标题/标签/logo 处理
     */
}

export { SiteUtil }
